import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useFormikContext } from "formik";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftReportProgress,
  CftActionsButtons,
  CftExportReport,
  CftTank,
} from "../../components";
import routes from "../../utils/cftRoutes";
import { useCft } from "../../utils/CftProvider";

import FertilizersFarmlandsForm, {
  FertilizersFarmlandsFormContext,
} from "../../forms/farmlands/FertilizersFarmlandsForm/FertilizersFarmlands.form";

function FertilizersPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { submitForm, values, isSubmitting } = useFormikContext();
  const { saveFarmlands, meta } = useCft();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={28}
          cropName={meta.title.farmlands}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportReport type="farmlands" />

              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveFarmlands({
                    fertilizers: values,
                  });
                  history.push(routes.FARMLANDS.MAIN);
                }}
              />
            </CftTank>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:fertilizers.title", "Nawozy")}
          onBack={() => history.push(routes.FARMLANDS.SOIL)}
          onNext={submitForm}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:fertilizers.title", "Nawozy")}</h3>
            <p>
              {t(
                "cft:fertilizers.subtitle",
                "Wprowadź dane dotyczące nawozów oraz środków ochrony roślin przed, w trakcie i po uprawie."
              )}
            </p>
          </>
        }
      >
        <FertilizersFarmlandsForm />
        <CftReportProgress type="farmlands" />
      </CftSection>
    </CftLayout>
  );
}

export default () => {
  return (
    <FertilizersFarmlandsFormContext>
      <FertilizersPage />
    </FertilizersFarmlandsFormContext>
  );
};
